import { toast } from 'react-toastify';
import { isValidEmail } from '../../../utils/utils';
import axios from '../../../utils/axios';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useInviteTeamMember } from '../InviteTeamMemberContext';

export const INVITE_ROLE = `idcloud:invites:add`;

export const useSaveInvite = currentUserActions => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });
  const { setErrors, setLoading } = useInviteTeamMember();

  const navigate = useNavigate();

  return async (form, isVendorCompany) => {
    setLoading(false);
    setErrors([]);

    try {
      setLoading(true);

      // validation
      if (!isValidEmail(form.email)) {
        setErrors([t('error.email.valid')]);
        return;
      }

      let propertyRoles = [];
      let globalAccess = false;
      let companyTitle = undefined;

      // Set values for standard company
      if (!isVendorCompany) {
        companyTitle = form.companyTitle ? form.companyTitle.value : form.companyTitle;
        form.properties.forEach(p => {
          propertyRoles.push({
            name: p.name,
            roleId: p.roleId
          });
        });
        globalAccess = form.globalAccess;
      }

      const postobj = {
        company: form.company,
        email: form.email,
        companyAdmin: form.isCompanyAdmin,
        companyRole: form.companyRole.value,
        companyTitle: companyTitle,
        propertyRoles: propertyRoles,
        useMfa: form.useMfa,
        globalAccess: globalAccess
      };

      let result = await axios.post(`/invites`, postobj);
      if (result.status === 200) {
        toast(t('Invitations.sent.user'));

        let path = `/users`;
        if (form.company) path += `?company=${encodeURIComponent(form.company)}`;
        navigate(path);
      } else if (result && result.data && result.data.errors) {
        setErrors(result.data.errors.map(err => err.message.split('---')[0]));
      } else {
        setErrors(t('error.general'));
      }
    } catch (e) {
      if (e.response && e.response.data) {
        setErrors(e.response.data.errors.map(err => err.message));
      } else {
        setErrors((e && e.message) || t('error.server'));
      }
    } finally {
      setLoading(false);
    }
  };
};
